<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_iii"></a>Seriatim</h1>
<p class="subtitle"><em>The Supreme Court before<br/>John Marshall</em></p>
<p class="author1"><span class="small">EDITED BY</span><br/><em>Scott Douglas Gerber</em></p>
<p class="publisher"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?12c252c8